// removed by extract-text-webpack-plugin
module.exports = {"project":"src-components----styles-module---project---1LO85"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles.module.css
// module id = 343
// module chunks = 48515692054781